export default __webpack_public_path__ + "static/media/connor.61c2af0a.png";